<template>
  <div id="app">
    <pagetitle v-if="$store.getters.getLogotitle!=-1" />
    <logotitle />
    <router-view/>
    <footerbox />
  </div>
</template>
<script>
import logotitle from "./components/logotitle.vue";
import pagetitle from "./components/pagetitle.vue";
import footerbox from "./components/footer.vue";
export default {
  name: 'App',
  components:{logotitle,footerbox,pagetitle},
  watch: {
    '$route': { // $route可以用引号，也可以不用引号  监听的对象
      handler(to, from){
        this.$store.commit('setLogotitle',to.meta.tab)
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    }
  }
}
</script>
<style lang="scss">
@import './assets/css/reset.scss';
</style>
